import {forwardRef} from 'react'
import {DatetimepickerProps} from 'react-datetime-3.1.1'
import {FormField, FieldBaseProps} from '../FormField'
import {Label} from '../Label'
import {DateField as JbcDateField} from 'jbc-front/components/presenters/form/DateField'
import {Required} from 'jbc-front/components/presenters/form/Label'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {Note} from 'jbc-front/components/presenters/ui/Note'

type DateFieldProps = DatetimepickerProps &
  FieldBaseProps & {
    disabled?: boolean
    placeholder?: string
    inputProps?: JSX.IntrinsicElements['input']
  }

export const DateField = forwardRef<HTMLInputElement, DateFieldProps>(
  ({label, required = false, note, error, ...dateFieldProps}, ref) => {
    const jbcDateFieldProps = {
      ...dateFieldProps,
      enabled: !dateFieldProps.disabled,
      inputProps: {
        ...dateFieldProps.inputProps,
        disabled: dateFieldProps.disabled,
      },
    }

    return (
      <FormField>
        {label && (
          <FormField.LabelContainer>
            <Label>
              {label}
              {required && <Required />}
            </Label>
          </FormField.LabelContainer>
        )}

        <JbcDateField {...jbcDateFieldProps} ref={ref} />

        {note && (
          <FormField.NoteContainer>
            <Note>{note}</Note>
          </FormField.NoteContainer>
        )}

        {error && (
          <FormField.ErrorContainer>
            <ErrorMessage>{error}</ErrorMessage>
          </FormField.ErrorContainer>
        )}
      </FormField>
    )
  }
)

DateField.displayName = 'DateField'
